import type {LanguageSelectorTranslation} from './languageSelectorTranslationType';
import type {ChatCoffeeLocaleId} from '../localeLoaders';
import type {ComponentTranslationServerDefinition} from 'microsites/core/chatMicrosite/translations/componentTranslations';

const languageSelectorTranslationSyncLoaders: Record<ChatCoffeeLocaleId, () => LanguageSelectorTranslation> = {
  'ar-MA': () => require(`./translations/ar-MA`).translation,
  'ar-SA': () => require(`./translations/ar-SA`).translation,
  'de-DE': () => require(`./translations/de-DE`).translation,
  'en-KE': () => require(`./translations/en-KE`).translation,
  'en-NG': () => require(`./translations/en-NG`).translation,
  'en-US': () => require(`./translations/en-US`).translation,
  'es-ES': () => require(`./translations/es-ES`).translation,
  'fa-IR': () => require(`./translations/fa-IR`).translation,
  'fr-FR': () => require(`./translations/fr-FR`).translation,
  'hi-IN': () => require(`./translations/hi-IN`).translation,
  'it-IT': () => require(`./translations/it-IT`).translation,
  'ja-JP': () => require(`./translations/ja-JP`).translation,
  'ko-KR': () => require(`./translations/ko-KR`).translation,
  'nl-NL': () => require(`./translations/nl-NL`).translation,
  'pt-PT': () => require(`./translations/pt-PT`).translation,
  'ru-RU': () => require(`./translations/ru-RU`).translation,
  'sv-SE': () => require(`./translations/sv-SE`).translation,
  'th-TH': () => require(`./translations/th-TH`).translation,
  'yue-Hant-HK': () => require(`./translations/yue-Hant-HK`).translation,
  'zh-Hans-CN': () => require(`./translations/zh-Hans-CN`).translation,
};

export const languageSelectorTranslationDefinition: ComponentTranslationServerDefinition<LanguageSelectorTranslation> = {
  cacheKey: `languageSelector`,
  syncLoaders: languageSelectorTranslationSyncLoaders,
};
